"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addNote = addNote;
exports.addConfigNotes = addConfigNotes;
exports.getLocalStorageNotesString = getLocalStorageNotesString;
exports.clearLocalstorageNotes = clearLocalstorageNotes;
/**
 * Adds a note base on the key to the note storage, overwrite if key already exists
 * @param key key to add
 * @param value value to add
 */
function addNote(key, value) {
    var noteStorage = JSON.parse(localStorage.getItem("note") || "{}");
    noteStorage[key] = value;
    localStorage.setItem("note", JSON.stringify(noteStorage));
}
/**
 * Adds all keys and values to the note local storage
 * @param notes an object with key value pairs for notes
 */
function addConfigNotes(notes) {
    if (!notes) {
        return;
    }
    console.log("reading config notes", notes);
    var noteStorage = JSON.parse(localStorage.getItem("note") || "{}");
    for (var _i = 0, _a = Object.entries(notes); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        noteStorage[key] = value;
    }
    localStorage.setItem("note", JSON.stringify(noteStorage));
}
/**
 *
 * @returns All notes in local storage in format key: value, key: value, ...
 */
function getLocalStorageNotesString() {
    var noteString = "";
    var noteStorage = JSON.parse(localStorage.getItem("note") || "{}");
    for (var _i = 0, _a = Object.entries(noteStorage); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        noteString += key + ": " + value + ", ";
    }
    // remove trailing ", "" 
    if (noteString) {
        noteString = noteString.substring(0, noteString.length - 2);
    }
    return noteString;
}
function clearLocalstorageNotes() {
    localStorage.removeItem("note");
}
